(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6343],{

/***/ 26200:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _BaseButton_module_css__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(966);
/* harmony import */ var _BaseButton_module_css__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_BaseButton_module_css__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var components_shared_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63057);
/* harmony import */ var components_Spinner_Spinner__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95475);









var Button = function(_param) {
    var children = _param.children, _variant = _param.variant, variant = _variant === void 0 ? "primary-gold" : _variant, _size = _param.size, size = _size === void 0 ? "large" : _size, isLoading = _param.isLoading, className = _param.className, onClick = _param.onClick, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "children",
        "variant",
        "size",
        "isLoading",
        "className",
        "onClick"
    ]);
    var cn = classnames__WEBPACK_IMPORTED_MODULE_2___default()((_BaseButton_module_css__WEBPACK_IMPORTED_MODULE_6___default()["default"]), (_BaseButton_module_css__WEBPACK_IMPORTED_MODULE_6___default())[variant], (_BaseButton_module_css__WEBPACK_IMPORTED_MODULE_6___default())[size], className);
    var handleClick = isLoading ? undefined : onClick;
    var marginStyle = (0,components_shared_utils__WEBPACK_IMPORTED_MODULE_3__/* .getMarginFromProps */ .X)(rest);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        className: cn,
        style: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, marginStyle),
        onClick: handleClick,
        disabled: isLoading
    }, rest), {
        children: isLoading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Spinner_Spinner__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {}) : children
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Button);


/***/ }),

/***/ 95102:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ HotelsCarousel_HotelsCarousel; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
// EXTERNAL MODULE: ./customHooks/useLocalised/useLocalised.ts + 2 modules
var useLocalised_useLocalised = __webpack_require__(91933);
;// CONCATENATED MODULE: ./blocks/Partners/assets/FS.png
/* harmony default export */ var FS = ({"src":"/_next/static/media/FS.b0f1b276.png","height":170,"width":310,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAADFBMVEUiHB8cHBwhGx5MaXHzjyhvAAAABHRSTlMpCh0AnFJv5AAAAAlwSFlzAAALEwAACxMBAJqcGAAAAB9JREFUeJwdxIEJADAQg0CN++9c+uBJtVV8N3VTYRcPBQsAN7SNSgUAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":4});
;// CONCATENATED MODULE: ./blocks/Partners/assets/luxury.png
/* harmony default export */ var luxury = ({"src":"/_next/static/media/luxury.01398321.png","height":140,"width":130,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAMAAAAC2hU0AAAAFVBMVEVERERBQUFDQ0NERERFRUVERERFRUUzl3u3AAAAB3RSTlMVASA5WERnwlATSQAAAAlwSFlzAAALEwAACxMBAJqcGAAAAC5JREFUeJw9xzEOwEAMwzDJcfL/Jx/QoQAX4nS7Mg102VFzbFT7nxtyQeaKhM8DEv0Ah+9bLlcAAAAASUVORK5CYII=","blurWidth":7,"blurHeight":8});
;// CONCATENATED MODULE: ./blocks/Partners/assets/small-luxury.png
/* harmony default export */ var small_luxury = ({"src":"/_next/static/media/small-luxury.250852f1.png","height":118,"width":149,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAMAAADJ2y/JAAAADFBMVEUAAAAAAAAAAAAAAAA16TeWAAAABHRSTlMpHzQXQSoUUwAAAAlwSFlzAAALEwAACxMBAJqcGAAAACVJREFUeJwdikEOADAQRDD//3OzdRJBNBTwhGMtoKyfdP5nOsYDBeMAONDZ5dEAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ./blocks/Partners/assets/PenClub.webp
/* harmony default export */ var PenClub = ({"src":"/_next/static/media/PenClub.bcbad9ef.webp","height":2000,"width":5000,"blurDataURL":"data:image/webp;base64,UklGRioAAABXRUJQVlA4IB4AAACQAQCdASoIAAMAAkA4JaQAAudP3WAA/v3FToHIAAA=","blurWidth":8,"blurHeight":3});
;// CONCATENATED MODULE: ./blocks/Partners/assets/PearlPartner.png
/* harmony default export */ var PearlPartner = ({"src":"/_next/static/media/PearlPartner.e2e8fd8b.png","height":309,"width":305,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAADFBMVEUvLy84ODg0NDQ2NjZ+cDihAAAABHRSTlMCCxYvoobJfgAAAAlwSFlzAAAuIwAALiMBeKU/dgAAACpJREFUeJw1i0EKAEAQgrT+/+dlgr0ogYExATgY8MZJ0k62qVkCuu5j9wcIlwA+de8xbAAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./blocks/Partners/assets/marriott.png
/* harmony default export */ var marriott = ({"src":"/_next/static/media/marriott.456e7519.png","height":128,"width":218,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAAFVBMVEVaWlptbW2jo6M/Pz9CQkJAQECsrKwOce9gAAAAB3RSTlMfDwNvT4RNPQWDsAAAAAlwSFlzAAALEwAACxMBAJqcGAAAACZJREFUeJwdw4ENwDAAwrAQaP8/eVotmXXbKbS0pyM8ormqJPn7AQjJAFLqjaBJAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./blocks/Partners/assets/jumeriah.png
/* harmony default export */ var jumeriah = ({"src":"/_next/static/media/jumeriah.26773d7e.png","height":296,"width":960,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAACVBMVEUiIiIeHh4gICAMeCZVAAAAA3RSTlMRITKj2kn6AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAE0lEQVR4nGNgZGRiYmJkZGKAAQAAsgANMebaUAAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":2});
;// CONCATENATED MODULE: ./blocks/Partners/assets/rocco.png
/* harmony default export */ var rocco = ({"src":"/_next/static/media/rocco.0569dac6.png","height":87,"width":290,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAADFBMVEUAAABMaXEAAAAAAACI9KeKAAAABHRSTlMJACJYDJm29gAAAAlwSFlzAAALEwAACxMBAJqcGAAAABhJREFUeJwFwQEBAAAIwyDm+3cWVFsFd3gAxgARfj2KUAAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":2});
;// CONCATENATED MODULE: ./blocks/Partners/assets/hyattprive.png
/* harmony default export */ var hyattprive = ({"src":"/_next/static/media/hyattprive.696d9564.png","height":36,"width":312,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAMAAADU3h9xAAAACVBMVEUODg4KCgoMDAwmm3rdAAAAA3RSTlMoNx/RJ35HAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAEUlEQVR4nGNgYGBgYGRkZAIAABQABgO3wrwAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":1});
;// CONCATENATED MODULE: ./blocks/Partners/assets/RosewoodElite.webp
/* harmony default export */ var RosewoodElite = ({"src":"/_next/static/media/RosewoodElite.d1e62905.webp","height":407,"width":1534,"blurDataURL":"data:image/webp;base64,UklGRlwAAABXRUJQVlA4WAoAAAAQAAAABwAAAQAAQUxQSBEAAAAARDs/O0k+PkAAAAAfHwAAAABWUDggJAAAAHABAJ0BKggAAgACQDglpJwAAFcAAP7vSeLyyFmOI3vsSAAAAA==","blurWidth":8,"blurHeight":2});
;// CONCATENATED MODULE: ./blocks/Partners/assets/leadingHotels.png
/* harmony default export */ var leadingHotels = ({"src":"/_next/static/media/leadingHotels.7d5f3ed2.png","height":138,"width":310,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAGFBMVEXm5ub+/v7w8PDY2Nj39/f////c3Ny5ubkpKa/iAAAABHRSTlP+9vz79gWNSQAAAAlwSFlzAAALEwAACxMBAJqcGAAAACRJREFUeJwVwoENADAMwrDQAv3/42mWkdiRRNJrEmx2bAP95wEGwgBeFFFsywAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":4});
;// CONCATENATED MODULE: ./blocks/Partners/assets/Virtuoso.gif
/* harmony default export */ var Virtuoso = ({"src":"/_next/static/media/Virtuoso.2a56d6a8.gif","height":972,"width":1971});
;// CONCATENATED MODULE: ./blocks/Partners/assets/RelaisChateux.png
/* harmony default export */ var RelaisChateux = ({"src":"/_next/static/media/RelaisChateux.80d91555.png","height":1763,"width":1690,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAM1BMVEUyIiK+n1cAAAAMCgXLqV27m1e8nlYAAAAJBwQAAAAjGQ7AoVe+oFe9nlfBn1q/n1e5mlVItnmqAAAAEXRSTlMBqVtGY1GHbS98HI+SbhYgIQ1m6ToAAAAJcEhZcwAALiMAAC4jAXilP3YAAAA7SURBVHicHcZZEoAwCAXBISE8yKLe/7SWfnXDdZ/zXMAyM1vAiIgYfNv7F3d3YPacPROyWqumRJJKpRcykAFhvSP6WgAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./blocks/Partners/assets/IHG.png
/* harmony default export */ var IHG = ({"src":"/_next/static/media/IHG.e93ec7d2.png","height":1677,"width":3544,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAD1BMVEUAAAAAAAAAAAAAAAAAAABPDueNAAAABXRSTlMQBBpIKUZKfaMAAAAJcEhZcwAALiMAAC4jAXilP3YAAAAgSURBVHicHcaxDQAACMOwpOX/mxF4MgqgSNv5JBkuzwUCrgAjd6nw1gAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":4});
;// CONCATENATED MODULE: ./blocks/Partners/assets/BelmondBellini.png
/* harmony default export */ var BelmondBellini = ({"src":"/_next/static/media/BelmondBellini.9b42ce42.png","height":232,"width":620,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAMAAACZFr56AAAADFBMVEXj4+P////X19fv7+9RUlxuAAAACXBIWXMAACxLAAAsSwGlPZapAAAAHElEQVR4nB3BgQ0AAAyDILX//7xkgFoqLmqyeAcB3gAeoiQhwgAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":3});
;// CONCATENATED MODULE: ./blocks/Partners/assets/trumpHotels.jpeg
/* harmony default export */ var trumpHotels = ({"src":"/_next/static/media/trumpHotels.470e4cc0.jpeg","height":750,"width":1350,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAEAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAf/xAAaEAACAwEBAAAAAAAAAAAAAAAAEQECAxIy/8QAFAEBAAAAAAAAAAAAAAAAAAAAAP/EABQRAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhEDEQA/AK/OFZ09XTa7kAAf/9k=","blurWidth":8,"blurHeight":4});
;// CONCATENATED MODULE: ./blocks/Partners/assets/barriere.png
/* harmony default export */ var barriere = ({"src":"/_next/static/media/barriere.98c14923.png","height":3520,"width":3520,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAFVBMVEVMaXEiFgQAAAB6Xw6uhhMAAACyihayLQEEAAAAB3RSTlMAB0IdOSI5GyxOvAAAAAlwSFlzAAALEwAACxMBAJqcGAAAAClJREFUeJxtycENACAMw0CbFPYfGVH1yb2sBH6qJnIE1KiwV0tP8r5xAQaUADW87MwjAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./blocks/Partners/assets/Impresario.png
/* harmony default export */ var Impresario = ({"src":"/_next/static/media/Impresario.89bf5309.png","height":190,"width":343,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAD1BMVEUhGBEKCgQKCgpMaXHFomiUoP0BAAAABXRSTlMTGQkAScjrMU0AAAAJcEhZcwAAFuoAABbqAeWOQxAAAAAgSURBVHicHcfBEQAACIMwWtx/Zk95BdQZFfKVAoGDfwsEeQAx33UKCwAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":4});
;// CONCATENATED MODULE: ./blocks/Partners/assets/DesignHotels.png
/* harmony default export */ var DesignHotels = ({"src":"/_next/static/media/DesignHotels.d03af2a5.png","height":210,"width":881,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAElBMVEUAAAAQDQwPDQwQEAwPDw8SEg0PbCq5AAAABnRSTlMCYU8pQjcJJUXrAAAACXBIWXMAACxLAAAsSwGlPZapAAAAFklEQVR4nGNgZAJDFgYGBmZWZmYGBgABBgAdfNS3iQAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":2});
;// CONCATENATED MODULE: ./blocks/Partners/assets/MandarinOriental.png
/* harmony default export */ var MandarinOriental = ({"src":"/_next/static/media/MandarinOriental.c0770186.png","height":2008,"width":3898,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAG1BMVEUAAAAAAABMaXEAAAAAAAAAAAAAAAAAAAAAAAAvL56bAAAACXRSTlMNGwAq1Ylggm4/4QP1AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAJElEQVR4nB3FwREAIAgDweSCYv8VO7CfFbhPQHCrHshxYmtsHwZ3AEbEFPQqAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":4});
;// CONCATENATED MODULE: ./blocks/Partners/assets/DorchesterCollection.jpg
/* harmony default export */ var DorchesterCollection = ({"src":"/_next/static/media/DorchesterCollection.0fd28b51.jpg","height":365,"width":1653,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAACAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAf/xAAaEAEAAwADAAAAAAAAAAAAAAABAAIDBBEh/8QAFQEBAQAAAAAAAAAAAAAAAAAAAgP/xAAXEQEAAwAAAAAAAAAAAAAAAAAAAQIx/9oADAMBAAIRAxEAPwCrZZ0ryAKVO1PCIiSvpQ//2Q==","blurWidth":8,"blurHeight":2});
;// CONCATENATED MODULE: ./blocks/Partners/Partners.tsx

























var partnersWithImg = [
    {
        name: "Four Seasons Preferred Partner",
        image: FS
    },
    {
        name: "Jumeirah Stay Different",
        image: jumeriah
    },
    {
        name: "The Leading Hotels Of The World",
        image: leadingHotels
    },
    {
        name: "Rose Wood Elite",
        image: RosewoodElite
    },
    {
        name: "Rocco Forte Hotels",
        image: rocco
    },
    {
        name: "The Luxury Circle",
        image: luxury
    },
    {
        name: "The Peninsula Pen Club",
        image: PenClub
    },
    {
        name: "Mandarin Oriental FANS",
        image: MandarinOriental
    },
    {
        name: "Small Luxury Hotels Of The World",
        image: small_luxury
    },
    {
        name: "Belmond Bellini Club",
        image: BelmondBellini
    },
    {
        name: "Pearl Partner Oetker Collection",
        image: PearlPartner
    },
    {
        name: "Hyatt Prive",
        image: hyattprive
    },
    {
        name: "Stars Marriott International",
        image: marriott
    },
    {
        name: "Virtuoso",
        image: Virtuoso
    },
    {
        name: "Relais & Chateaux",
        image: RelaisChateux
    },
    {
        name: "IHG Hotels & Resorts",
        image: IHG
    },
    {
        name: "Trump Hotels",
        image: trumpHotels
    },
    {
        name: "Barri\xe8re Hotels",
        image: barriere
    },
    {
        name: "Impresario",
        image: Impresario
    },
    {
        name: "Design Hotels",
        image: DesignHotels
    },
    {
        name: "Dorchester Collection Diamond Club",
        image: DorchesterCollection
    }, 
];
var Partners = function() {
    var partners_section_title_text = useLocalised(partners_section_title);
    return /*#__PURE__*/ _jsxs("div", {
        className: "partners-container",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "partners-container__title",
                children: partners_section_title_text
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "partners-container__icons-container",
                children: partnersWithImg.map(function(partner) {
                    return /*#__PURE__*/ _jsx("div", {
                        className: "icon",
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "icon__container",
                            children: /*#__PURE__*/ _jsx("div", {
                                className: "partner-icon",
                                children: /*#__PURE__*/ _jsx(Image, {
                                    src: partner.image,
                                    alt: partner.name,
                                    objectFit: "contain",
                                    layout: "fill"
                                })
                            })
                        })
                    }, partner.name);
                })
            })
        ]
    });
};
/* harmony default export */ var Partners_Partners = ((/* unused pure expression or super */ null && (Partners)));

// EXTERNAL MODULE: ./components/icons/ArrowLeft.tsx
var ArrowLeft = __webpack_require__(5505);
// EXTERNAL MODULE: ./components/icons/ArrowRight.tsx
var ArrowRight = __webpack_require__(10997);
// EXTERNAL MODULE: ./node_modules/next/future/image.js
var future_image = __webpack_require__(61608);
var future_image_default = /*#__PURE__*/__webpack_require__.n(future_image);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/HotelsCarousel/HotelsCarousel.module.css
var HotelsCarousel_module = __webpack_require__(91149);
var HotelsCarousel_module_default = /*#__PURE__*/__webpack_require__.n(HotelsCarousel_module);
// EXTERNAL MODULE: ./components/text/index.ts
var components_text = __webpack_require__(22538);
// EXTERNAL MODULE: ./components/container/index.ts
var container = __webpack_require__(49985);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/divider/index.ts
var divider = __webpack_require__(81367);
;// CONCATENATED MODULE: ./components/HotelsCarousel/HotelsCarousel.tsx












var HotelsCarousel = function(param) {
    var _isPartner = param.isPartner, isPartner = _isPartner === void 0 ? false : _isPartner, _showControlls = param.showControlls, showControlls = _showControlls === void 0 ? true : _showControlls, className = param.className, mt = param.mt;
    var ref = (0,react.useState)([]), hotels = ref[0], setHotels = ref[1];
    var ref1 = (0,react.useState)(0), current = ref1[0], setCurrent = ref1[1];
    var length = hotels.length;
    var recalculate = function() {
        var width = window.innerWidth > 1170 ? 1170 - 60 : window.innerWidth - 60;
        var modules = Math.floor(width / 250);
        var temp = [];
        for(var i = 0; i < partnersWithImg.length; i += modules){
            temp.push(partnersWithImg.slice(i, i + modules));
        }
        setHotels(temp);
    };
    (0,react.useEffect)(function() {
        recalculate();
    }, []);
    (0,react.useEffect)(function() {
        window.addEventListener("resize", recalculate, false);
    }, []);
    (0,react.useEffect)(function() {
        var width = window.innerWidth > 1170 ? 1170 - 60 : window.innerWidth - 60;
        var slider = document.getElementById("carousel");
        if (slider) {
            slider.scrollTo({
                left: current * width,
                behavior: "smooth"
            });
        }
    }, [
        current
    ]);
    var nextSlide = function() {
        setCurrent(current >= length - 1 ? 0 : current + 1);
    };
    var prevSlide = function() {
        setCurrent(current === 0 ? length - 1 : current > length - 1 ? length - 2 : current - 1);
    };
    var hotelCardClass = classnames_default()((HotelsCarousel_module_default()).image, (0,_define_property/* default */.Z)({}, (HotelsCarousel_module_default()).partner, isPartner));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(container/* default */.Z, {
        as: "section",
        className: classnames_default()((HotelsCarousel_module_default()).carousel, className),
        mt: mt,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(container/* default */.Z, {
                className: (HotelsCarousel_module_default()).titleContainer,
                children: [
                    isPartner && /*#__PURE__*/ (0,jsx_runtime.jsx)(divider/* default */.Z, {
                        mr: 60,
                        width: 140,
                        color: "gold-dark"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Heading */.X6, {
                        align: "center",
                        as: "h5",
                        weight: "demiBold",
                        fontSize: "31.6px",
                        children: "Our prestigious hotel partners"
                    }),
                    isPartner && /*#__PURE__*/ (0,jsx_runtime.jsx)(divider/* default */.Z, {
                        ml: 60,
                        width: 140,
                        color: "gold-dark"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(container/* default */.Z, {
                className: (HotelsCarousel_module_default()).container,
                id: "carousel",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    className: (HotelsCarousel_module_default()).content,
                    children: hotels.map(function(hotel, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: (HotelsCarousel_module_default()).group,
                            children: hotel.map(function(hotel, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: hotelCardClass,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((future_image_default()), {
                                        src: hotel.image,
                                        alt: hotel.name,
                                        width: 100,
                                        height: 100,
                                        className: (HotelsCarousel_module_default()).hotelLogos
                                    })
                                }, index);
                            })
                        }, index);
                    })
                })
            }),
            showControlls && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (HotelsCarousel_module_default()).buttons,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: (HotelsCarousel_module_default()).button_prev,
                        onClick: prevSlide,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowLeft/* default */.Z, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: (HotelsCarousel_module_default()).button_next,
                        onClick: nextSlide,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRight/* default */.Z, {})
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var HotelsCarousel_HotelsCarousel = (HotelsCarousel);


/***/ }),

/***/ 69028:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var components_shared_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63057);
/* harmony import */ var components_text_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13394);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);






var Divider = function(_param) {
    var _as = _param.as, as = _as === void 0 ? "div" : _as, _direction = _param.direction, direction = _direction === void 0 ? "h" : _direction, _height = _param.height, height = _height === void 0 ? 1 : _height, width = _param.width, style = _param.style, _color = _param.color, color = _color === void 0 ? "grey-medium" : _color, children = _param.children, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "as",
        "direction",
        "height",
        "width",
        "style",
        "color",
        "children"
    ]);
    var marginStyle = (0,components_shared_utils__WEBPACK_IMPORTED_MODULE_0__/* .getMarginFromProps */ .X)(rest);
    var colorStyle = (0,components_text_utils__WEBPACK_IMPORTED_MODULE_1__/* .getColorFromString */ .T)(color);
    var backgroundColor = colorStyle || (style === null || style === void 0 ? void 0 : style.backgroundColor);
    return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.createElement)(as, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        style: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, marginStyle, style), {
            width: width,
            height: height,
            backgroundColor: backgroundColor
        })
    }, rest));
};
/* harmony default export */ __webpack_exports__["Z"] = (Divider);


/***/ }),

/***/ 81367:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _Divider__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _Divider__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(69028);



/***/ }),

/***/ 966:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"default":"BaseButton_default__OOxIm","primary-gold":"BaseButton_primary-gold__nlw99","primary-black":"BaseButton_primary-black__4obai","secondary-dark-grey":"BaseButton_secondary-dark-grey__1uTe2","secondary-white":"BaseButton_secondary-white__8gmRG","secondary-ghost":"BaseButton_secondary-ghost__QLilf","full":"BaseButton_full__ctUcM","large":"BaseButton_large__EBpgm","medium":"BaseButton_medium__sfmQ1","small":"BaseButton_small__Ou0rI","xs":"BaseButton_xs__VALNV"};

/***/ }),

/***/ 91149:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"carousel":"HotelsCarousel_carousel__EcuNW","title":"HotelsCarousel_title__ypEPB","container":"HotelsCarousel_container__1u5c_","content":"HotelsCarousel_content__eex4P","group":"HotelsCarousel_group__1sL6M","image":"HotelsCarousel_image__Zax63","hotelLogos":"HotelsCarousel_hotelLogos__rifx4","buttons":"HotelsCarousel_buttons__BHgzy","button_prev":"HotelsCarousel_button_prev__jOjyE","button_next":"HotelsCarousel_button_next__NAqrP","partner":"HotelsCarousel_partner__z_UHP","titleContainer":"HotelsCarousel_titleContainer__VjcqK"};

/***/ })

}]);